import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import moment from 'moment'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';

import DeliveryViewDetails from './DeliveryViewDetails'

class DeliveryView extends Component {

    constructor(){
        super();
        
        this.state={
            
            info : {},
            products : {},
            delivery :{}
           
        }
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });
        
        let quotation = ref.child("Delivery").child(this.props.match.params.did);
            quotation.on("value", function(snap){
                this.setState({
                    products : snap.val().products,
                    info: snap.val().customer,
                    delivery : snap.val()
                })
            }.bind(this))
            
    } 
    

   

    
    render() {
            
            
        return (                        
                <div id="page-wrapper">                 
                    <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                        <Sidebar  />
                        <div id="main-container">
                            <Header />
                            <div id="page-content">
                                <Title title="Delivery" />                          
                                <div className="block">
                                  <div className="block full">
                                    <div className="block-title">
                                      <h2><strong></strong> </h2>
                                    </div>                                  
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label className="col-md-4 text-right">Date Of Delivery</label>
                                            <div className="col-md-8">
                                                <input className="form-control"   type="text" value={this.state.delivery.date}required/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-6">
                                            <label className="col-md-4 text-right">To</label>
                                            <div className="col-md-8">
                                                <input className="form-control"  ref={input=>this.customerName=input} type="text" value={this.state.info && this.state.info.name}required/>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label className="col-md-4 text-right">Address</label>
                                            <div className="col-md-8">
                                                <input className="form-control"  ref={input=>this.address=input} type="text"  value={this.state.info && this.state.info.location} required/>
                                            </div>
                                        </div>
                                    </div>

                                    <table id="ecom-products" className="table table-bordered table-striped table-vcenter">
                                        <thead>
                                            <tr>               
                                                <th className="text-center">QTY</th>
                                                <th className="text-center">Unit</th>
                                                <th className="text-center">Articles</th>
                                                
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.products &&
                                                    Object.keys(this.state.products).map(function (key){
                                                        let list = this.state.products[key]
                                                        return <DeliveryViewDetails  key={key} product = {list} />
                                                   }.bind(this))
                                            }
                                        </tbody>
                                    </table>
                                    
                                  </div>    
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
      
        );
    }
}

export default DeliveryView;



// WEBPACK FOOTER //
// ./src/components/DeliveryView.js